<template>
  <div class="searchorders">
    <h1 class="subheading grey--text">Ebay Item Editor</h1>

    <v-container class="my-1">
      <v-text-field
        v-model="searchTerm"
        @keyup="doFilter"
        label="Enter ebay item description, model or item list"
        prepend-icon="mdi-filter"
        clearable
      ></v-text-field>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="itemList"
        item-key="name"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Edit Item</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.ebayItem" label="Ebay Item"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.ebayModel" label="Ebay Model"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.itemList" label="Item List"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <!-- workaround for lint -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  components: {},
  data() {
    return {
      dialog: false,
      currentPayment: {},
      cartId: "",
      searchTerm: "",
      itemsRaw: [],
      itemList: [],
      cartContents: [],
      selected: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      inputRules: [
        v => !!v || "This field is required",
        v => v.length === 36 || "CartId must be 36 characters"
      ],
      loading: false,
      headers: [
        { text: "Ebay Item", value: "ebayItem" },
        { text: "Ebay Model", value: "ebayModel" },
        { text: "Item List", value: "itemList" },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },
  created() {
    this.getEbayItemList();
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    async getEbayItemList() {
      this.loading = true;
      this.itemsRaw = await cartApi.getEbayItems();
//      this.$log.info(JSON.stringify(this.itemsRaw));
      await this.doFilter();
      this.loading = false;
    },
    async doFilter() {
      if (!this.searchTerm || this.searchTerm.length == 0) {
        this.itemList = this.itemsRaw;
      } else {
        this.itemList = this.itemsRaw.filter(
          item =>
            item.ebayItem.includes(this.searchTerm) ||
            item.ebayModel.includes(this.searchTerm) ||
            item.itemList.includes(this.searchTerm)
        );
      }
    },
    editItem(item) {
      this.editedIndex = this.itemList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.itemList.indexOf(item);
      if (confirm("Are you sure you want to delete this item? " + this.itemList[index].ebayItem)) {
        await cartApi.deleteEbayItem(this.itemList[index].id);
        this.getEbayItemList();
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        Object.assign(this.itemList[this.editedIndex], this.editedItem);
        await cartApi.putEbayItem(this.editedItem.id, 
                                  this.editedItem.ebayItem, 
                                  this.editedItem.ebayModel, 
                                  this.editedItem.itemList);
      } else {
        this.itemList.push(this.editedItem);
        await cartApi.postEbayItem( this.editedItem.ebayItem, 
                                    this.editedItem.ebayModel, 
                                    this.editedItem.itemList);
      }                         
      this.close();             
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    searchDisabled() {
      if (!this.cartId || this.cartId === undefined) {
        return true;
      } else {
        return this.cartId.length !== 36;
      }
    }
  }
};
</script>
